<template>
  <div class="grid grid-cols-[minmax(30px,150px)_1fr] gap-4 items-center mt-8">
    <FormLabel label="Personal notes">
      <FormKit type="checkbox" name="notes" />
    </FormLabel>
    <FormLabel label="Notes">
      <FormKit type="text" name="notesText" />
    </FormLabel>
    <FormLabel label="Price">
      <FormKit type="text" name="notesPrice" />
    </FormLabel>
    <DiscountField
      checkboxName="notesDiscount"
      priceTypeName="notesDiscountType"
      priceName="notesDiscountPrice"
      :values="values"
    />
  </div>
</template>
<script setup>
import DiscountField from "@/components/Order/DiscountField/DiscountField.vue";
import FormLabel from "../../../UI/Form/FormLabel.vue";

defineProps({
  values: {
    type: Object,
    default: () => ({}),
  },
});
</script>
